import baseVariables from 'bitmovin-web-ui/src/styles/baseVariables';
import React from 'react';
import styled from 'styled-components';

import BoundImageModal from '../../components/boundImageModal';
import {pxToEm} from '../../components/globalStyles';
import ProductOverviewGif from '../../media/aboutUsPageView/product_overview.gif';

//#region Styled Components

const StyledWrapperDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  > div:first-child {
    flex: 7;
    margin-right: ${pxToEm(80)}em;
  }

  > div:last-child {
    flex: 4;
  }
`;

const StyledImg = styled.img`
  width: 100%;
`;

const headerFontSizePx = 24;
const StyledH2 = styled.h2`
  font-size: ${pxToEm(headerFontSizePx)}em;
  color: ${baseVariables.colors.midnight};
  margin-bottom: ${pxToEm(40) / pxToEm(headerFontSizePx)}em;
`;

const StyledP = styled.p`
  font-size: ${pxToEm(16)}em;
  line-height: 1.6;
`;

const StyledA = styled.a`
  text-decoration: none;
  color: ${baseVariables.colors.bitmovinBlue};
`;

//#endregion

const ProductOverviewSection: React.FunctionComponent = () => {
  return (
    <StyledWrapperDiv>
      <div>
        <BoundImageModal
          boundComponent={<StyledImg src={ProductOverviewGif} alt="Product overview gif" />}
          source={ProductOverviewGif}
        />
      </div>

      <div>
        <StyledH2>Want to learn how to use our products quickly</StyledH2>
        <StyledP>
          You can find lots of helpful resources right in the dashboard view of the portal and on the platform.
        </StyledP>
        <StyledP>Make sure to also follow our blog for regular updates and news about our technologies.</StyledP>
        <StyledP>
          Our extended
          <StyledA href="https://www.bitmovin.com/docs" target="_blank">
            &nbsp;Developer Documentation&nbsp;
          </StyledA>
          will guide you through examples of how to integrate our solution into your business.
        </StyledP>

        <StyledP>Please also follow our blog for regular updates and news about our technologies.</StyledP>

        <StyledP>
          And don’t forget to become part of the
          <StyledA href="https://community.bitmovin.com/" target="_blank">
            &nbsp;Bitmovin Community
          </StyledA>
          , where you can connect, explore, learn and share experiences with media developers worldwide.
        </StyledP>
      </div>
    </StyledWrapperDiv>
  );
};

export default ProductOverviewSection;
